/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_OverlineInputs */

const en_mk_sec_overline = /** @type {(inputs: Mk_Sec_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YOUR CODE STAYS YOURS`)
};

const id_mk_sec_overline = /** @type {(inputs: Mk_Sec_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KODEMU TETAP MILIKMU`)
};

/**
* | output |
* | --- |
* | "YOUR CODE STAYS YOURS" |
*
* @param {Mk_Sec_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_overline = /** @type {((inputs?: Mk_Sec_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_overline(inputs)
	return en_mk_sec_overline(inputs)
});